import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from '../../shared/utility/utility';
import { acceptedCreditCardsRegex } from '../../cashier/config/cashier.config';
import { CustomValidators } from '../../shared/utility/custom-validator';

@Injectable({
  providedIn: 'root'
})
export class CardService {
  
  constructor(public translationServiceParam: TranslateService) { }

  static creditCardValidator(utils: Utility) {
    return function (control: FormControl) {
      let cardno;
      if(control.get("creditcardNumber")){
        cardno = control.get("creditcardNumber");
      }else if(control.get("cardNumber")){
        cardno = control.get("cardNumber");
      }
      if (cardno.value) {
        const ccNumber = cardno.value.toString().split('-').join('');
        let newCard;
        if(control.get("cardId")){
          newCard = control.get("cardId").value;
        }else if(control.get("accountId")){
          newCard = control.get("accountId").value;;
        }
        let regEx = /^[0-9]*$/;
        let mindigit = 2;
        let message;
        if (newCard === 0) {
          if (!ccNumber) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error10') });
            message = { 'message': CustomValidators.translationService.instant('errors.error10') };
          } else if (ccNumber && !regEx.test(ccNumber)) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error18') });
            message = { 'message': CustomValidators.translationService.instant('errors.error18') };
          } else if (ccNumber && !utils.creditCardValidation(ccNumber)) {
            cardno.setErrors({ 'message': CustomValidators.translationService.instant('errors.error19') });
            message = { 'message': CustomValidators.translationService.instant('errors.error19') };
          } else {
            message = null;
          }
        } else {
          message = null;
        }


        return message;
      } else {
        return "";
      }
    };
  }



  checkCredicardValidation(min,max){
    return function (control: FormControl) {
      let message:any = "";
      let cardNumber = control.value ? control.value.trim() : control.value;
      cardNumber = cardNumber.replaceAll(' ','');
      if(!cardNumber){
        message = { 'message': CustomValidators.translationService.instant('cashierErrors.error1') }
      control.setErrors(message);
      return message
      }
     
     if(cardNumber && !parseInt(cardNumber) || cardNumber && parseInt(cardNumber) != cardNumber){
        control.setValue(cardNumber.slice(0,-1));
        message = { 'message': CustomValidators.translationService.instant('cashierErrors.error1') }
        control.setErrors(message);
        return message
        return
      }
      let isValid = false;
      
     if(cardNumber.length > max){
        cardNumber= cardNumber.slice(0,max);
        let res = [...cardNumber].map((d, i) => (i) % 4 == 0 ? ' ' + d : d).join('').trim()
        control.setValue(res);
     }else if(cardNumber.length < min ){
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error3') }
      control.setErrors(message);
       return message
     }else if(cardNumber.length >= min  && cardNumber.length <= max){
         message = '';
     }
     if(message)
       return message

      acceptedCreditCardsRegex.filter((cardRegex:any)=>{
        let data:any = Object.values(cardRegex);
        if(data[0].test(cardNumber)){
          isValid = true;
        }
      });
      if(!isValid){
        message = CustomValidators.translationService.instant('cashierErrors.error2')
      }
      if(message)
      return { message: message };
     return null;
    };
}

checkCvvValidation(min,max){
  return function (control: FormControl) {
    let cardCvv = control.value ? control.value.trim() : control.value;
    cardCvv= cardCvv.toString();
    let message:any = "";
    if(!cardCvv || (cardCvv.length == 3 && !parseInt(cardCvv))){
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error1') }
      control.setErrors(message);
      return message;
    }
   
    if(cardCvv.length >max){
       cardCvv= cardCvv.slice(0,max);
       control.setValue(cardCvv);
       return null;
    }else if(cardCvv.length < min ){
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error4') }
      control.setErrors(message);
    }else if(cardCvv.length == min  || cardCvv.length == max){
      control.setErrors(null);
    }
    if(message){
      return message
    }
    return null;
  };

 
}
expCardData(min, max) {
  return function (control: FormControl) {
    let expMonth; 
    let expYear;
    let regEx = /^[0-9]*$/;
    let date = new Date();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let message;
    let expiryYearPrefix = date.getFullYear().toString().slice(0,2);

    if(!control.value){
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error1') };
      control.setErrors(message);
      return message
    }
    if(control.value && control.value.length && control.value.length > 5){
      control.setValue(control.value.slice(0,5));
    }
   let data =  control.value.split('/');
   if(data.length != 2){
       message = { 'message': CustomValidators.translationService.instant('cashierErrors.error5') };
       control.setErrors(message);
       return message
   }
   expMonth = data && data[0] ? data[0] : undefined;
   expYear = data && data[1] ? expiryYearPrefix+data[1] : undefined;
   
    if (!expMonth) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error7') };
      control.setErrors(message);
    } else if (!regEx.test(expMonth)) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error8') }
      control.setErrors(message);
    } else if (expMonth < 1 || expMonth > 12) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error8') }
      control.setErrors(message);
    } else if (!expYear) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error7') }
      control.setErrors(message);
    } else if (!regEx.test(expYear)) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error9') }
      control.setErrors(message);
    } else if (expYear && (expYear).length < 4) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error9') }
      control.setErrors(message)
    } else if (expYear < year) {
      message = { 'message': CustomValidators.translationService.instant('cashierErrors.error9') }
      control.setErrors(message)
    } else if (expYear == year) {
      if (expMonth < month) {
        message = { 'message': CustomValidators.translationService.instant('cashierErrors.error8') }
        control.setErrors(message)
      } else if (expMonth > 12) {
        message = { 'message': CustomValidators.translationService.instant('cashierErrors.error8') }
        control.setErrors(message);
      } else {
        control.setErrors(null);
      }
    } else if (expYear > year) {
      message = null
      control.setErrors(null);
    }
    return message;
  };
}
}
